
  import React from "react"
  import Component from "/Users/fabianbrenes/squidsource/src/layouts/portfolio-item.js"
  import data from "/Users/fabianbrenes/squidsource/.cache/json/layout-portfolio-item.json"

  export default (props) => <Component {...props} {...data} />
  


// WEBPACK FOOTER //
// ./.cache/layouts/portfolio-item.js